import { useLocation } from 'react-router-dom'
import DoctorForm from './doctor'
import PatientForm from './patient'
import InstitutionForm from './institution'
const CompleteProfilePage = () => {
  const { state }: any = useLocation()
  if (state?.role == 'doctor') {
    return <DoctorForm />
  } else if (state?.role == 'institution') {
    return <InstitutionForm />
  } else {
    return <PatientForm />
  }
}

export default CompleteProfilePage
